const UpDown = () => (
   <svg fill='none' height='24' viewBox='0 0 16 16' width='24'>
      <path
         d='M4.99935 11.6663V4.33301M4.99935 4.33301L7.33268 6.66634M4.99935 4.33301L2.66602 6.66634M10.9993 4.33301V11.6663M10.9993 11.6663L13.3327 9.33301M10.9993 11.6663L8.66602 9.33301'
         stroke='currentColor'
         strokeLinecap='round'
         strokeLinejoin='round'
         strokeWidth='0.9'
      />
   </svg>
);
export default UpDown;
